import * as tslib_1 from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";
import { TokenManager } from "./token-manager.service";
import { default_const } from "../constants/consts";
import { ApiHandler } from "./api-handler.service";
import { API } from "src/environments/environment";
var DrawerService = /** @class */ (function () {
    function DrawerService(router, token, apiHandler) {
        var _this = this;
        this.router = router;
        this.token = token;
        this.apiHandler = apiHandler;
        this.body = document.getElementsByTagName("body")[0];
        this.htmlRoot = document.getElementsByTagName("html")[0];
        this.selectedLanguage = default_const.Default_Language["key"];
        //
        if (localStorage.getItem("selectedLanguage")) {
            this.selectedLanguage = JSON.parse(localStorage.getItem("selectedLanguage"));
        }
        if (localStorage.getItem("selectedLanguageData")) {
            this.selectedLanguageData = JSON.parse(localStorage.getItem("selectedLanguageData"));
        }
        // const getLangKey = this.selectedLanguage;
        var getLangKey = this.selectedLanguage;
        if (getLangKey) {
            this.selectedLanguage = getLangKey;
        }
        this.languageChange$ = new BehaviorSubject(this.selectedLanguage);
        this.languageChangeData$ = new BehaviorSubject(this.selectedLanguageData);
        this.globalImageData$ = new BehaviorSubject("");
        // ============== language change data========
        this.languageChangeData$.subscribe({
            next: function (result) {
                _this.selectedLanguageData = result;
                // for arabic language only
                //  console.log(result)
                _this.token.storeDataByKey(default_const.selectedLanguageData, _this.selectedLanguageData);
                if (_this.selectedLanguageData) {
                    if (_this.selectedLanguageData.name === "AR") {
                        _this.body.classList.add("arabic-lang");
                        _this.htmlRoot.setAttribute("lang", "ar");
                        _this.htmlRoot.setAttribute("dir", "rtl");
                    }
                    else {
                        _this.body.classList.remove("arabic-lang");
                        _this.htmlRoot.setAttribute("lang", "en");
                        _this.htmlRoot.removeAttribute("dir");
                    }
                }
            },
        });
    }
    DrawerService.prototype.setAndUpdatelanguageSelction = function (dataObj, data) {
        this.selectedLanguage = dataObj;
        this.selectedLanguageData = data;
        this.languageChange$.next(dataObj);
        this.languageChangeData$.next(data);
    };
    DrawerService.prototype.updateLanguage = function (formData) {
        return this.apiHandler.apiPost(API.COMMON_ENDPOINT.UPDATE_LANGUAGE, formData);
    };
    DrawerService.prototype.getLanguageList = function () {
        return this.apiHandler.apiGet(API.COMMON_ENDPOINT.GET_ALL_LANGUAGE_LIST);
    };
    DrawerService = tslib_1.__decorate([
        Injectable({
            providedIn: "root"
        }),
        tslib_1.__metadata("design:paramtypes", [Router, TokenManager, ApiHandler])
    ], DrawerService);
    return DrawerService;
}());
export { DrawerService };
//# sourceMappingURL=drawer.service.js.map